const debounce = (fn, wait) => {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
};

class ProductImages extends HTMLElement {
  constructor() {
    super();
    this.slideEl = this.querySelector(".swiper");
    this.desktopImages = this.querySelectorAll("[data-image-index]");
    this.thumbsnails = this.querySelectorAll("[data-thumbnail]");
    this.thumbsWrapper = this.querySelector("[data-thumbs-wrapper]");

    window.loadSwiper.then(({ Swiper }) => {
      const swiperParams = {
        slidesPerView: "auto",
        scrollbar: {
          el: ".swiper-scrollbar",
          draggable: true,
        },
      };

      this.swiper = new Swiper(this.slideEl, swiperParams);
    });

    this.thumbsnails.forEach((thumbnail) => {
      thumbnail.addEventListener("click", () => {
        const index = thumbnail.getAttribute("data-thumbnail");
        this.slideTo(index);
      });
    });

    this.desktopImages.forEach((image) => {
      image.addEventListener("click", (e) => {
        const html = image.outerHTML;
        e.target.dispatchEvent(
          new CustomEvent("markup-modal:open", {
            bubbles: true,
            detail: { html, target: "zoom-modal" },
          }),
        );
      });
    });
  }

  connectedCallback() {
    this.setThumbsPosition();

    window.addEventListener(
      "resize",
      debounce(this.setThumbsPosition.bind(this), 200),
    );

    // on scroll see if any of this.desktopImages are past .header and if so, update the thumbnail
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const index = entry.target.getAttribute("data-image-index");
            debounce(this.updateThumb(index), 200);
          }
        });
      },
      {
        threshold: 0.85,
      },
    );

    this.desktopImages.forEach((image) => {
      observer.observe(image);
    });
  }

  setThumbsPosition() {
    //get total height of this.thumbswrapper
    const totalHeight = this.thumbsWrapper.scrollHeight;
    const thumbs = this.thumbsWrapper.querySelector("[data-thumbs]");
    const thumbsHeight = thumbs.scrollHeight;

    thumbs.style.top = `calc(${totalHeight / this.desktopImages.length}px - ${thumbsHeight}px)`;
  }

  slideTo(index) {
    const imageToView = this.querySelector(`[data-image-index="${index}"]`);
    imageToView.scrollIntoView();
  }

  updateThumb(index) {
    this.thumbsnails.forEach((thumbnail) => {
      thumbnail.classList.remove("is-selected");
      if (thumbnail.getAttribute("data-thumbnail") === index) {
        thumbnail.classList.add("is-selected");
      }
    });
  }
}

if (!customElements.get("product-images")) {
  customElements.define("product-images", ProductImages);
}
